import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { LoginService } from "@app/modules/auth/login/services/login.service";
import { ToastrMessageService } from "@app/shared/services/toastr-message/toastr-message.service";
import { Observable, of } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { LocalStorageService } from "@app/shared/services/local-storage/local-storage.service";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private loginService: LoginService,
    private toastrMessageService: ToastrMessageService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private cookieService: CookieService,
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // We should not add access_token to login, register & refreshToken API's
    const urlToIgnore = /(login|register)/i;

    // if (request.url.search(urlToIgnore) === -1) {
    //   request = request.clone({
    //     setParams: {
    //       access_token: this.loginService.getTokenFromCookie(),
    //     },
    //   });
    // }
    if (!urlToIgnore.test(request.url)) {
      const token = this.loginService.getTokenFromCookie();

      if (token) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
      }
    }


    return next.handle(request).pipe(
      tap((evt) => {
        if (evt instanceof HttpResponse) {
          // console.log(evt);
        }
      }),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          console.log("console:", err);
          if (err.status == 0) {
          }
          else if (err.status === 401) {
            this.toastrMessageService.showWarning(err.error.message ||
              "Session expired. Please login again." +
              "Unauthorized"
            );
            this.localStorageService.clearLocalStorage();
            this.cookieService.deleteAll();
            this.router.navigate(["/login"]);

          }
          //Forbidden
          else if (err.status === 403) {
            this.toastrMessageService.showError(err.error.message ||
              "You do not have permission to perform this action." +
              "Access Denied"
            );
          }
          // Server error
          else if (err.status === 500) {
            err.error.message ||
            this.toastrMessageService.showError(
              "Internal server error. Please contact support." +
              "Server Error"
            );
          }
          //  Other errors
          else {
            this.toastrMessageService.showError(err.error.message ||
              err || "Something went wrong" +
              "Error"
            );
          }
        }
        return of(err);
      })
    );
  }
}
